import React, { Component}  from 'react';

const Background = () => (
  <div id="background">
  	<div className="container" id="content">
  	</div>
  </div>
);

export default Background;


// WEBPACK FOOTER //
// ./src/Background.js